import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BuyPutSvg = (props: any) => (<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 5V22" stroke="#888888" strokeOpacity="0.4"/>
        <path d="M5 14H22" stroke="#888888" strokeOpacity="0.4"/>
        <path d="M21 17H12.332L10 14" stroke="#A40C0C"/>
        <path d="M10 14L5 7" stroke="#089981"/>
    </svg>

)


const BuyPut: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BuyPutSvg(props)}
    </SvgIcon>
));
export default BuyPut
